import i from "../letterSpacing/letterSpacing.js";
import t from "../lineHeight/lineHeight.js";
const e = {
  "7xl": "4.5rem",
  // 72px
  "6xl": "3.75rem",
  // 60px
  "5xl": "3rem",
  // 48px
  "4xl": "2.25rem",
  // 36px
  "3xl": "1.875rem",
  // 30px
  "2xl": "1.5rem",
  // 24px
  xl: "1.25rem",
  // 20px
  lg: "1.125rem",
  // 18px
  base: "1rem",
  // 16px
  sm: "0.875rem",
  // 14px
  xs: "0.75rem"
  // 12px
}, l = {
  "display-lg": [
    e["7xl"],
    {
      lineHeight: t[2],
      letterSpacing: i.tight
    }
  ],
  "display-sm": [
    e["6xl"],
    {
      lineHeight: t[2],
      letterSpacing: i.tight
    }
  ],
  "title-1": [
    e["5xl"],
    {
      lineHeight: t[3],
      letterSpacing: i.tight
    }
  ],
  "title-2": [
    e["4xl"],
    {
      lineHeight: t[4],
      letterSpacing: i.tight
    }
  ],
  "title-3": [
    e["3xl"],
    {
      lineHeight: t[4],
      letterSpacing: i.tight
    }
  ],
  "title-4": [
    e["2xl"],
    {
      lineHeight: t[4],
      letterSpacing: i.tight
    }
  ],
  "title-5": [
    e.xl,
    {
      lineHeight: t[5],
      letterSpacing: i.tight
    }
  ],
  "title-6": [
    e.lg,
    {
      lineHeight: t[5],
      letterSpacing: i.tight
    }
  ],
  "body-lg": [
    e.lg,
    {
      lineHeight: t[6]
    }
  ],
  "body-md": [
    e.base,
    {
      lineHeight: t[6]
    }
  ],
  "body-sm": [
    e.sm,
    {
      lineHeight: t[6]
    }
  ],
  "body-xs": [
    e.xs,
    {
      lineHeight: t[6]
    }
  ],
  "caption-lg": [
    e.lg,
    {
      lineHeight: t[5]
    }
  ],
  "caption-md": [
    e.base,
    {
      lineHeight: t[5]
    }
  ],
  "caption-sm": [
    e.sm,
    {
      lineHeight: t[5]
    }
  ],
  "caption-xs": [
    e.xs,
    {
      lineHeight: t[5]
    }
  ],
  overline: [
    e.xs,
    {
      lineHeight: t[1],
      letterSpacing: i.px
    }
  ]
}, r = {
  ...e,
  ...l
};
export {
  r as default
};
